import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';
import { getAllControllingPersons } from './getAllControllingPersons';

export const ADD_CONTROLLING_PERSON_REQUEST = 'ADD_CONTROLLING_PERSON_REQUEST';
export const ADD_CONTROLLING_PERSON_SUCCESS = 'ADD_CONTROLLING_PERSON_SUCCESS';
export const ADD_CONTROLLING_PERSON_FAILURE = 'ADD_CONTROLLING_PERSON_FAILURE';

function addControllingPersonRequest() {
  return {
    type: ADD_CONTROLLING_PERSON_REQUEST
  };
}

function addControllingPersonRecieved(controllingPersons) {
  return {
    type: ADD_CONTROLLING_PERSON_SUCCESS,
    controllingPersons
  };
}

function addControllingPersonFailed() {
  return {
    type: ADD_CONTROLLING_PERSON_FAILURE,
  };
}

export function addControllingPerson(accountId, entityFormId, cpFormId, cpType) {
  return (dispatch) => {
    dispatch(addControllingPersonRequest());
    const promise = () => ApiService
      .addControllingPerson(accountId, entityFormId, cpFormId, cpType)
      .then((response) => {
        dispatch(addControllingPersonRecieved(response.data));
        toastr.success('Success', 'Controlling person added successfully');
        dispatch(getAllControllingPersons(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, addControllingPersonFailed, true));
        }
      });
    return promise();
  };
}
